import { lang } from '@umu/ukit-lang';
import React, { Component } from 'react';
import { components } from 'common';
const { If, Loading } = components;
import { $document, $window, isPassiveListenerSupported, hitBottom } from '@umu/umu-dom';
import { debounce } from '@umu/umu-util';
import './infiniteScroll.scss';

interface IProps {
    load: () => void;
    hasMore: boolean;
    isLoading: boolean;
    viewportSelector?: Element;
    scrollerSelector?: Element;
    bottomDistance?: number;
    scrollThreshold?: number;
    endRender?: () => JSX.Element;
    initTop?: boolean;
    isLoadedData?: boolean;
    emptyText?: string;
    hideLoading?: boolean;
}

interface IState {
    isScrollLoading: boolean;
}

const DEFAULT_SCROLL_THRESHOLD = 200;
const DEFAULT_BOTTOM_DISTANCE = 180;

export default class InfiniteScroll extends Component<IProps, IState> {
    public bottomDistance: number;
    public isLoadedData: boolean;
    public listContainer: Window | Element = $window;
    constructor(props: IProps) {
        super(props);
        this.state = {
            isScrollLoading: false,
        };
        this.isLoadedData = false;
        this.bottomDistance = props.bottomDistance || DEFAULT_BOTTOM_DISTANCE;

        this.bindEvent = this.bindEvent.bind(this);
        this.scrollEvent = debounce(this.scrollEvent, props.scrollThreshold || DEFAULT_SCROLL_THRESHOLD);
    }

    public componentDidUpdate(preProps: IProps) {
        // 滚动容器发生了变化，重新绑定滚动事件
        if (
            preProps.viewportSelector !== this.props.viewportSelector ||
            preProps.scrollerSelector !== this.props.scrollerSelector
        ) {
            this.listContainer.removeEventListener('scroll', this.scrollEvent, false);
            this.bindEvent();
        }
    }

    public componentDidMount() {
        this.bindEvent();
        if (!this.props.initTop) {
            return;
        }
        if (this.props.viewportSelector) {
            const ele = this.listContainer as Element;
            if (ele.scrollTop) {
                try {
                    ele.scrollTo({
                        top: 0,
                    });
                } catch (error) {
                    //
                }
            }
            return;
        }

        const documentElement = $document.documentElement;
        if (documentElement && documentElement.scrollTop) {
            if (documentElement.scrollTop > 0) {
                try {
                    documentElement.scrollTo({
                        top: 0,
                    });
                } catch (error) {
                    // nothing
                }
            }
        } else {
            const body = $document.body;
            if (body && body.scrollTop) {
                if (body.scrollTop > 0) {
                    try {
                        body.scrollTo({
                            top: 0,
                        });
                    } catch (error) {
                        // nothing
                    }
                }
            }
        }
    }
    public componentWillUnmount() {
        this.listContainer.removeEventListener('scroll', this.scrollEvent, false);
    }

    public bindEvent() {
        const passive = isPassiveListenerSupported() ? { passive: true } : false;
        if (this.props.viewportSelector) {
            this.listContainer = this.props.viewportSelector || $window;
        }
        this.listContainer.addEventListener('scroll', this.scrollEvent, passive);
    }

    public scrollEvent = () => {
        if (!this.props.hasMore) {
            return;
        }
        let viewportEl;
        let scrollerEl;
        if (this.props.viewportSelector && this.props.scrollerSelector) {
            viewportEl = this.props.viewportSelector || undefined;
            scrollerEl = this.props.scrollerSelector || undefined;
        }
        if (hitBottom(this.bottomDistance, viewportEl, scrollerEl)) {
            this.setState({
                isScrollLoading: true,
            });
            this.props.load();
            this.isLoadedData = true;
        } else {
            this.setState({
                isScrollLoading: false,
            });
        }
    };

    public endRender() {
        if (this.props.endRender) {
            return this.props.endRender();
        } else {
            return <div className="infinite-scroll-end-text">{this.props.emptyText || lang('没有更多数据了')}</div>;
        }
    }

    public render() {
        const { hasMore, hideLoading } = this.props;
        return (
            <div className="infinite-scroll-list">
                {this.props.children}
                <If condition={hasMore && !hideLoading && this.state.isScrollLoading}>
                    <Loading />
                </If>
                <If
                    condition={
                        !this.props.hasMore && !this.props.isLoading && (this.isLoadedData || !!this.props.isLoadedData)
                    }
                >
                    <div className="end-text">{this.endRender()}</div>
                </If>
            </div>
        );
    }
}
